import { useEffect } from "react";
import { useEmployeeAuth } from "./AdminProvider";
import { useNavigate } from "react-router-dom"
import { PaymentSuccess } from "../User/My Account/PaymentSuccess";
export const RequireAdmin = ({children}) =>{
    const auth = useEmployeeAuth()
    console.log(auth)
    const navigate = useNavigate();
    // useEffect(()=>{
    //     if (!auth.isAdmin===true){
    //         navigate("/admin/login", {replace:true})
    //     }
    // })
    return auth.isAdmin?children:<PaymentSuccess OnClose={()=>navigate('/admin/customers')} title={'You dont have permissions'} subtitle={'This page requires admin permissions'}/>
}